/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

// eslint-disable-next-line no-restricted-imports
import type { ExpoTvConnectRemoteModule as ExpoTvConnectRemoteModuleClass } from "./src/ExpoTvConnectRemote.types";

// eslint-disable-next-line no-restricted-imports
export * from "./src/ExpoTvConnectRemote.types";

// eslint-disable-next-line no-restricted-imports
export type * from "./src/ExpoTvConnectRemote.types";

export const ExpoTvConnectRemoteModule = CustomPlatform.select<
  () => ExpoTvConnectRemoteModuleClass
>({
  native: () => require("./src/ExpoTvConnectRemoteModule").default,
  web: () => require("./src/ExpoTvConnectRemoteModule.web").default,
  tv: () => require("./src/ExpoTvConnectRemoteModule.web").default,
  default: () => require("./src/ExpoTvConnectRemoteModule.web").default,
})();
